import {useState} from 'react'

import {Icon, IconButton, Link, Modal, Text} from '@ua/design-system'

import ContactSupport from 'airship/components/InProductSupport/index'
import getUrl from 'airship/modules/get-url'
import getContext from 'airship/modules/page-context'
import type {PageContext} from 'airship/modules/report-error/initialize'

import CustomerFeedbackModal from '../CustomerFeedbackModal'

const HelpMenu: React.FunctionComponent = () => {
  const [supportModalIsOpen, setSupportModalIsOpen] = useState(false)
  const [customerFeedbackModal, setCustomerFeedbackModal] = useState(false)
  const [reportModal, setReportModal] = useState(false)
  const context = getContext<PageContext>()

  const openFeedbackModal = (): void => {
    setSupportModalIsOpen(false)
    setCustomerFeedbackModal(true)
  }

  const openReportModal = (): void => {
    setSupportModalIsOpen(false)
    setReportModal(true)
  }

  return (
    <>
      <IconButton
        aria-label="Help"
        tooltip
        icon={<Icon name="question" size="sm" weight="regular" />}
        size="sm"
        variant="hollow"
        onClick={() => setSupportModalIsOpen(true)}
        bg="background.secondary"
      />
      <Modal
        isOpen={supportModalIsOpen}
        heading="Help and feedback"
        onClose={() => setSupportModalIsOpen(false)}
        size="lg"
      >
        <div className="grid-columns grid-columns-3 md ">
          <div className="u-border-sm u-border-radius-sm u-pad-0 u-space-items-6">
            <Text variant="captionMedium">RESOURCES</Text>
            <ul className="u-list-unstyled u-space-items-0">
              <li className="u-space-left-none">
                <Link href="https://docs.airship.com/whats-new/" target="blank">
                  What&apos;s new
                </Link>
              </li>
              <li className="u-space-left-none">
                <Link href="https://docs.airship.com/" target="blank">
                  Documentation
                </Link>
              </li>
              <li className="u-space-left-none">
                <Link
                  href={getUrl('js-urls:flight_school:index')}
                  target="_blank"
                >
                  Flight School
                </Link>
              </li>
            </ul>
          </div>

          <div className="u-border-sm u-border-radius-sm u-pad-0 u-space-items-6">
            <Text variant="captionMedium">GET HELP</Text>
            <ul className="u-list-unstyled u-space-items-0">
              <li className="u-space-left-none">
                <Link
                  href="https://support.airship.com/hc/en-us/community/topics"
                  target="blank"
                >
                  Community Forums
                </Link>
              </li>
              <li className="u-space-left-none">
                <Link href="#" onClick={openReportModal}>
                  Get support
                </Link>
              </li>

              <li className="u-space-left-none">
                <Link href="#" onClick={openReportModal}>
                  Report an error
                </Link>
              </li>
            </ul>
          </div>

          <div className="u-border-sm u-border-radius-sm u-pad-0 u-space-items-6">
            <Text variant="captionMedium">SEND US FEEDBACK</Text>
            <ul className="u-list-unstyled u-space-items-0">
              <li className="u-space-left-none">
                <Link href="#" onClick={openFeedbackModal}>
                  Share product feedback
                </Link>
              </li>
            </ul>
          </div>
        </div>
      </Modal>
      <CustomerFeedbackModal
        isOpen={customerFeedbackModal}
        onClose={() => setCustomerFeedbackModal(false)}
        name={context.context_processors.sentry_data.USER?.username}
        email={context.context_processors.sentry_data.USER?.email}
      />
      <ContactSupport
        isOpen={reportModal}
        onClose={() => setReportModal(false)}
      />
    </>
  )
}

export default HelpMenu
